// Maps cover names to IDs used to tag KB items
export const PRODUCT_ID_MAP = {
  "Personal accident": "personal-accident",
  "Professional indemnity": "professional-indemnity",
  "Public / product liability": "public-liability",
  "Excess protection": "excess-sum-insured",
  "Hospitalisation cash plan": "hospital-cash-plan",
  "Business and office equipment": "include-contents",
  "Contract works": "include-contract-works",
  "Hired-in plant": "include-hired-plant",
  "Stock": "include-stock-online",
  "Tools": "include-tools",
  "Legal expenses": "legal-expenses",
  "Own plant": "include-own-plant",
};

export const SELECTORS = {
  CHAT_WRAPPER: ".js-reco-chat-wrapper",
  CHAT_INPUT: ".js-reco-chat-input",
  MESSAGES_ELEMENT: ".reco-chat-messages-inner",
  SEND_BUTTON: ".reco-chat-send-icon",
  INLINE_PROMPTS: ".reco-chat-prompts-outer",
  LIVE_CHAT_PROMPT: ".reco-chat-live-chat-prompt",
}